
import { Event }     from './event';
import { EventType } from './event.type';
import {empty} from "@/util/util";

/**
 *
 * @class ClickEvent
 *
 * details about mouse clicks
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class ClickEvent extends Event {

  /** was it a left or right click? */
  private _left: boolean   = true;

  /** was it a single or double click? */
  private _single: boolean = true;

  /** was it pressed or released? */
  private _up: boolean     = false;

  /** the click position (x) */
  private _x: number       = 0;

  /** the click position (y) */
  private _y: number       = 0;

  /** standard constructor */
  constructor(krpano : any, type : EventType, left: boolean, single: boolean, up: boolean, x: number, y: number) {

    super(krpano, type);

    this._left   = left;
    this._single = single;
    this._up     = up;
    this._x      = x;
    this._y      = y;

  }

  /** was it a left click? */
  left(): boolean {

    return this._left;
  }

  /** was it a right click? */
  right(): boolean {

    return !this._left;
  }

  /** was it a single click? */
  single(): boolean {

    return this._single;
  }

  /** was it a double click? */
  double(): boolean {

    return !this._single;
  }

  /** was it released? */
  up(): boolean {

    return this._up;
  }

  /** was it pressed? */
  down(): boolean {

    return !this._up;
  }

  /** fetch the click position (x) */
  x(): number {

    return this._x;
  }

  /** fetch the click position (y) */
  y(): number {

    return this._y;
  }

}
